// Calendly popup wrapper. Every "Schedule a Content Audit" CTA calls openBooking()
// which triggers the Calendly popup widget for the configured URL.
import { createContext, useContext, useCallback } from "react";

export const CALENDLY_URL = "https://calendly.com/namrata-kothari";

const BookingCtx = createContext({ openBooking: () => {} });

export const BookingProvider = ({ children }) => {
  const openBooking = useCallback(() => {
    if (typeof window === "undefined") return;
    if (window.Calendly && typeof window.Calendly.initPopupWidget === "function") {
      window.Calendly.initPopupWidget({ url: CALENDLY_URL });
    } else {
      // Fallback if widget script hasn't loaded yet
      window.open(CALENDLY_URL, "_blank", "noopener,noreferrer");
    }
  }, []);

  return (
    <BookingCtx.Provider value={{ openBooking }}>
      {children}
    </BookingCtx.Provider>
  );
};

export const useBooking = () => useContext(BookingCtx);
